// extracted by mini-css-extract-plugin
export var body = "_oh-8";
export var button = "_oh-0";
export var closeButton = "_oh-5";
export var content = "_oh-3";
export var empty = "_oh-f";
export var grid = "_oh-c";
export var header = "_oh-4";
export var icon = "_oh-1";
export var option = "_oh-d";
export var optionSelected = "_oh-e";
export var overlay = "_oh-2";
export var searchIcon = "_oh-a";
export var searchInput = "_oh-b";
export var searchWrapper = "_oh-9";
export var title = "_oh-6";
export var visuallyHidden = "_oh-7";